export const CONVERTIBLE = 'CONVERTIBLE';
export const LIMOUSINE = 'LIMOUSINE';
export const STATION_WAGON = 'STATION_WAGON';
export const SUV_PICKUP = 'SUV_PICKUP';
export const VAN_TRANSPORTER = 'VAN_TRANSPORTER';
export const COUPE_SPORT = 'COUPE_SPORT';
export const OTHER = 'OTHER';
export const CONVERTIBLE_COUPE = 'CONVERTIBLE_COUPE';
export const SMALL_CAR = 'SMALL_CAR';
export const ROADSTER = 'ROADSTER';
export const CHASSIS_CAB = 'CHASSIS_CAB';
export const PANEL_VAN = 'PANEL_VAN';
export const PANEL_VAN_HIGH = 'PANEL_VAN_HIGH';
export const PANEL_VAN_HIGH_LONG = 'PANEL_VAN_HIGH_LONG';
export const PANEL_VAN_LONG = 'PANEL_VAN_LONG';
export const TRUCK_WITH_BOX_BODY = 'TRUCK_WITH_BOX_BODY';
export const PLATFORM_CAB = 'PLATFORM_CAB';
export const OTHER_COMMERCIAL = 'OTHER_COMMERCIAL';
export const TIPPER = 'TIPPER';
export const BUS = 'BUS';
